import type { AxiosResponse } from "axios";
import type { RouteLocationNormalized } from "vue-router";

import type { LoginResponse } from "@/backend/http/auth";
import Auth from "@/backend/http/auth";
import { loggedIn } from "@/backend/read/BackendReader";
import { isCloud } from "@/utils/env/Environment";
import { firstQueryParam } from "@/utils/vue/queryParam";

import { companyParam } from "./utils";

export async function beforeLogin(to: RouteLocationNormalized) {
  // going back from the app
  if (loggedIn()) {
    return { path: "/", replace: true };
  }

  // directly accessing the login page
  try {
    if (await Auth.isAuthenticated()) {
      return { path: firstQueryParam(to.query, "path") || "/", replace: true };
    }
  } catch {
    // not authenticated — fall through to login page
  }

  if (isCloud) {
    const companyId = companyParam();
    if (!companyId) {
      return;
    }
    // go to FusionAuth login page with company already resolved
    const res = await Auth.login({
      type: firstQueryParam(to.query, "type") || "",
      path: firstQueryParam(to.query, "path") || "",
      companyId,
    });
    return followRedirect(res);
  }

  // go to FusionAuth login page
  const res = await Auth.loginPage({
    type: firstQueryParam(to.query, "type") || "",
    path: firstQueryParam(to.query, "path") || "",
  });
  return followRedirect(res);

  function followRedirect(res: AxiosResponse<LoginResponse>) {
    if (res.data.success && res.data.redirectUrl) {
      window.location.assign(res.data.redirectUrl);
      return false;
    }
  }
}
